import PropTypes from 'prop-types';

const Panel = ({ children = null, style = {}, title = null }) => (
  <div
    className="db-panel-wrapper"
    style={{
      position: 'relative',
      marginBottom: '20px',
      backgroundColor: 'white',
      ...style,
    }}
  >
    {title ? <span className="global-panel-title">{title}</span> : null}
    <div>{children}</div>
  </div>
);

Panel.propTypes = {
  style: PropTypes.object,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  title: PropTypes.node,
};

export default Panel;
